module.exports = __webpack_public_path__ + "img/q.0f8d58fc.png";